import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store ={
  state:{ //状态对象：共享值的集合
    bgColor:'#fff',
  },
  mutations:{  //同步修改
    set(state, obj){//初始化
      for(let name in obj){
        state[name] = obj[name];
      }
    },
  },
  getters:{//监测状态
    bgColor:(state)=>{
      return state.bgColor
    },
  },
  actions:{//异步修改
    update(context,obj){ //context 上下文对象，同管全局
      context.commit('set',obj); //上下文对象调用commit执行add方法
    },
  }
}

export default store

